import * as actionTypes from "constants/dashboard/actionTypes";

export const fetchDashboardStats = () => {
  return {
    type: actionTypes.FETCH_DASHBOARD_STATS,
    payload: {}
  };
};

export const setDashboardStats = ({ stats }) => {
  return {
    type: actionTypes.SET_DASHBOARD_STATS,
    payload: {
      stats
    }
  };
};

export const setDashboardStatsError = ({ errorMessage }) => {
  return {
    type: actionTypes.SET_DASHBOARD_STATS_ERROR,
    payload: {
      errorMessage
    }
  };
};
